import { DateTime } from 'luxon';

export const MONDAY_ONLY_WEEK_START_ERROR = 'Please select a Monday to view the weekly report';

declare global {
  interface Window {
    _env_?: { APP_VERSION?: string };
  }
}

/** Report footer text per wireframe (UDOMI-908). */
export function getReportFooterText(): string {
  const version = window._env_?.APP_VERSION ?? '1.2.2';
  return `TrussUS Dealer Portal - Version ${version}`;
}

export function isMondayDateString(dateString: string): boolean {
  if (!isValidISODate(dateString)) {
    return false;
  }
  return DateTime.fromISO(dateString).weekday === 1;
}

/**
 * Get the most recent Monday from a given date (or today).
 * Used for week-based report date selection.
 */
export function getMostRecentMonday(fromDate?: DateTime): DateTime {
  const date = fromDate ?? DateTime.local();
  const weekday = date.weekday; // 1 = Monday, 7 = Sunday
  if (weekday === 1) {
    return date;
  }
  return date.minus({ days: weekday - 1 });
}

/**
 * Validates whether a given string is a valid ISO 8601 date.
 * Used for date input validation in reports.
 */
export function isValidISODate(dateString: string): boolean {
  if (!dateString || typeof dateString !== 'string') {
    return false;
  }
  const date = DateTime.fromISO(dateString);
  return date.isValid;
}

export function formatReportDate(dateStr: string): string {
  const dt = DateTime.fromISO(dateStr);
  return dt.isValid ? dt.toFormat('MMM dd, yyyy') : dateStr;
}

export function formatReportCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}
